"use client"

import { forwardRef } from "react"
import styles from "./Button.module.css"

const Button = forwardRef(
  (
    {
      children,
      variant = "primary",
      size = "medium",
      loading = false,
      disabled = false,
      fullWidth = false,
      leftIcon,
      rightIcon,
      onClick,
      type = "button",
      className = "",
      ...props
    },
    ref,
  ) => {
    const isDisabled = disabled || loading

    const buttonClasses = [
      styles.button,
      styles[variant],
      styles[size],
      loading && styles.loading,
      isDisabled && styles.disabled,
      fullWidth && styles.fullWidth,
      className,
    ]
      .filter(Boolean)
      .join(" ")

    const handleClick = (e) => {
      if (isDisabled) {
        e.preventDefault()
        return
      }
      if (onClick) onClick(e)
    }

    const content = (
      <>
        {loading && <span className={styles.spinner} aria-hidden="true" />}
        {leftIcon && !loading && (
          <span className={styles.leftIcon} aria-hidden="true">
            {leftIcon}
          </span>
        )}
        <span className={loading ? styles.hiddenText : styles.text}>{children}</span>
        {rightIcon && !loading && (
          <span className={styles.rightIcon} aria-hidden="true">
            {rightIcon}
          </span>
        )}
      </>
    )

    return (
      <button
        {...props}
        ref={ref}
        className={buttonClasses}
        disabled={isDisabled}
        onClick={handleClick}
        type={type}
        aria-disabled={isDisabled}
        
      >
        {content}
      </button>
    )
  },
)

Button.displayName = "Button"

export default Button
